import { render, staticRenderFns } from "./horarioIngresoEdit.vue?vue&type=template&id=0b62ca68&"
import script from "./horarioIngresoEdit.vue?vue&type=script&lang=js&"
export * from "./horarioIngresoEdit.vue?vue&type=script&lang=js&"
import style0 from "./horarioIngresoEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports